import {getDuration} from "@/assets/plugins/mps-common/time/duration-util";

const isThresholdExceededOf = (datetime) => {
    if (!datetime) return true;
    const duration = getDuration(datetime);
    return duration.values.days > 0 || duration.values.months > 0 || duration.values.years > 0;
}

export {isThresholdExceededOf}